import { Injectable } from '@angular/core';
import { TranslateService } from '../../../core/translation';
import { LoadingService } from '../../../shared/loading/loading.service';
import { MessageService } from '../../../shared/message/message.service';

declare let gapi: any;
declare let google: any;

@Injectable({
  providedIn: 'root'
})
export class GooglePickerService {
  clientId = '60456379428-1opve1c1nk7prdusfe790vnkp2vf3ajq.apps.googleusercontent.com';
  apiKey = 'AIzaSyAOmt142gt2qoxeJe4bMKyAhB1_Chbn4Kk';
  discoveryDocs = ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest'];
  scopes = 'https://www.googleapis.com/auth/drive'
  'https://www.googleapis.com/auth/drive.appdata'
  'https://www.googleapis.com/auth/drive.file'
  'https://www.googleapis.com/auth/drive.metadata'
  'https://www.googleapis.com/auth/drive.metadata.readonly'
  'https://www.googleapis.com/auth/drive.photos.readonly'
  'https://www.googleapis.com/auth/drive.readonly'
  'https://www.googleapis.com/auth/drive.scripts';
  pickerApiLoaded = false;
  accessToken = '';
  pickerCallback = null;
  file = '';
  language = 'es';
  primaryExtension = '';
  extensions = '';

  constructor(
    public _message: MessageService,
    public loading: LoadingService,
    public _translate: TranslateService)
    { }

  initClient(callback) {
    this.pickerCallback = callback;
    gapi.load('client:auth2', { callback: this.initClient2.bind(this) });
    gapi.load('picker', { callback: this.onPickerApiLoad.bind(this) });
  }

  initClient2() {
    gapi.client.init({
      apiKey: this.apiKey,
      clientId: this.clientId,
      discoveryDocs: this.discoveryDocs,
      scope: this.scopes
    }).then(() => {

    });
  }

  onPickerApiLoad() {
    gapi.auth.authorize(
      {
        client_id: this.clientId,
        scope: this.scopes,
        immediate: false,
      }
    ).then(() => {
      this.pickerApiLoaded = true;
      this.accessToken = gapi.auth2.getAuthInstance().currentUser.get().getAuthResponse().access_token;
      if (this.accessToken) {
        this.createPicker(this.accessToken);
      }
    });
  }

  createPicker(token: any): void {
    if (this.pickerApiLoaded && this.accessToken) {
      let view = new google.picker.DocsView()
      .setIncludeFolders(true)
      .setMimeTypes('application/vnd.google-apps.folder')
      view.setMimeTypes(this.extensions)
      let picker = new google.picker.PickerBuilder()
        .enableFeature(google.picker.Feature.NAV_HIDDEN)
        .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
        .setOAuthToken(token)
        .addView(view)
        .setLocale(this.language)
        .setCallback(this.pickerCallback)
        .build();
      picker.setVisible(true);
    }
  }

  async proceesFile(file) {
    try {
      let response = await fetch(`https://www.googleapis.com/drive/v3/files/${file}?alt=media&key=${this.apiKey}`, { headers: {
        'Authorization': 'Bearer ' + this.accessToken
      }});
      let blob = await response.blob();
      return blob;
    } catch (error) {
      this._message.showError(this._translate.instant('error_proccess_file'));
      this.loading.set(false);
    }
  }


  returnFile() {
    return this.file;
  }

  setPickerConfig(primaryExtension, language) {
    this.primaryExtension = primaryExtension;
    this.language = language;

    const extensions = this.primaryExtension.toLowerCase();
    const ext = this.removeDuplicateCharacters(extensions);

    switch (true) {
      case ext.includes('xml') && ext.includes('pdf'):
        this.extensions = 'application/pdf,text/xml';
        break;
      case ext.includes('pdf') && !ext.includes('xml'):
        this.extensions = 'application/pdf';
        break;
      case !ext.includes('pdf') && ext.includes('xml'):
        this.extensions = 'text/xml';
        break;
      case ext === '':
        this.extensions = '';
        break;
    }
  }

  removeDuplicateCharacters(word) {
    return word
      .split('')
      .filter(function(item, pos, self) {
        return self.indexOf(item) == pos;
      })
      .join('');
  }
}
